





















































































































import {
  defineComponent,
  PropType,
  ref,
  reactive,
  computed,
  useStore,
} from '@nuxtjs/composition-api'
import { sectionCoreProps } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic'
import TeleportV2 from '@/components/TeleportV2.vue'
import BlockModal from '@/components/BlockModal.vue'
import { ButtonAction } from '@/contracts/ButtonHeroAction'
import BlockButtons from '@/components/BlockButtons.vue'
import { CardTitleDescriptionImage as ICardTitleDescriptionImage } from '@/contracts/Cards'

export default defineComponent({
  name: 'SectionCardsPopupInfo',
  components: {
    BlockButtons,
    BlockModal,
    TeleportV2,
    SectionBasic,
  },
  mixins: [sectionCoreProps],
  props: {
    items: {
      type: Array as PropType<ICardTitleDescriptionImage[]>,
      default: () => [],
    },
    actionButtons: {
      type: Array as PropType<ButtonAction[]>,
      default: () => [],
    },
  },
  setup() {
    const store = useStore()
    const TRANSITION_DURATION = {
      enter: 500,
      leave: 100,
    }
    const popupIsVisible = ref(false)
    const modalContent: {
      title: string
      description: string
      style: null
    } = reactive({
      title: null,
      description: null,
      style: null,
    })
    const isMobile = computed<boolean>(
      (): boolean => store.getters['mediaQuery/isMobileMq']
    )
    const agileOptions = computed(() => ({
      navButtons: false,
      infinite: false,
      dots: true,
      speed: 800,
      slidesToShow: 1,
      centerMode: true,
    }))

    const getCardStyle = (card: ICardTitleDescriptionImage) => ({
      '--card-background-color': card.backgroundColor,
      '--card-title-color': card.titleColor,
      '--card-description-color': card.descriptionColor,
      '--card-modal-description-color': card.textColor,
      '--card-modal-title-color': card.titleTextColor,
    })

    const onOpenModal = (card: ICardTitleDescriptionImage) => {
      modalContent.title = card.title
      modalContent.description = card.text
      modalContent.style = getCardStyle(card)
      popupIsVisible.value = true
    }
    const onCloseModal = () => {
      popupIsVisible.value = false
    }

    return {
      TRANSITION_DURATION,
      modalContent,
      onOpenModal,
      onCloseModal,
      popupIsVisible,
      isMobile,
      agileOptions,
      getCardStyle,
    }
  },
})
